import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const systemBullSemen: ImportTypeConfig = {
  type: 'system-bull-semen',
}
